<!--
    BUTTON TO ACCESS THE ORTHANC IMAGE DATABASE
    © AREA 19, OCG WEB APP.
    DEVELOPED IN MONTREAL, QC, CANADA.
    FEBRUARY 2025.
  -->
<script setup lang="ts">
import { orthancJwt } from '@src/core/useOrthancAuth';
import { useOrthancStore } from '@src/store/dicom-web/orthanc-store';
import { computed, ref, watch } from 'vue';

import { session } from '../supabase';
import AppSettingsItem from './AppSettingsItem.vue';

const orthancToken = ref<string | null>(null);
const orthancUrl = ref<string | null>(null);
const orthancLink = computed(() => {
  return (
    orthancUrl.value
    && orthancToken.value
    && `${orthancUrl.value}?token=${orthancToken.value}`
  );
});

function loadOrthanc() {
  if (orthancLink.value) {
    window.open(orthancLink.value, '_blank');
  }
}

const orthancStore = useOrthancStore();

watch(
  session,
  async () => {
    try {
      const { id, url } = await orthancStore.getConfig();
      orthancUrl.value = url.replace('/dicom-web', '/ui/app/#/');
      orthancToken.value = await orthancJwt(id);
    }
    catch (e) {
      console.warn('No Orthanc config found', e);
      orthancToken.value = null;
      orthancUrl.value = null;
    }
  },
  { immediate: true },
);
</script>

<template>
  <AppSettingsItem
    v-if="!!orthancLink"
    icon="fa-solid fa-database"
    text="Orthanc"
    @click="loadOrthanc"
  />
</template>

<style scoped></style>
